
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'

import { mapGetters, mapActions } from 'vuex';
import navbar from '@/component/page-header.vue';
import vuex from '@/store/index';

console.log(vuex)
export default {
components: { ViewBox, Tabbar, navbar },
name: 'app',
data() {
return {
selected: '',
aa: '',
transitionName: 'slide-left',
linkArr: [
{
name: '首页',
url: '#/',
navName: 'index',
act: true,
icon: 'icon-home'
},
{
name: '服务',
url: '#/service',
navName: 'service',
act: false,
icon: 'icon-service'
},
{
name: '培训',
url: '#/train',
navName: 'train',
act: false,
icon: 'icon-training'
},
{
name: '助手',
url: '#/assistant',
navName: 'assistant',
act: false,
icon: 'icon-assistant'
},
{
name: '商城',
url: '#/shopping',
navName: 'shopping',
act: false,
icon: 'icon-store'
}
]
};
},
methods: {
...mapActions([]),
getNavName() {
for (let i = 0; i < this.linkArr.length; i++) {
if (this.linkArr[i].navName === this.navbarText) {
this.linkArr[i].act = true;
} else {
this.linkArr[i].act = false;
}
}
},
hashChange() {
this.$refs.viewBox.scrollTo(0);
},
clickright(e) {
if(e === 'saveinfo') {
vuex.dispatch('AgetisSave', true);
}
}
},
watch: {
navbarText() {
this.getNavName();
}
},
computed: {
...mapGetters(['showtabbar', 'tabberSwite', 'navbarText', 'navbarSwite','isSave'])
},
created() {
this.getNavName();
document.body.addEventListener('touchstart', function () {});



























},
mounted() {
if (
'onhashchange' in window &&
(typeof document.documentMode === 'undefined' ||
document.documentMode === 8)
) {
window.onhashchange = this.hashChange;
}
}
};
